// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Person } from './person';
import { VisitType } from './visit-type';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Visit extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  date!: Date;
  notes?: string;
  personId?: number;
  typeId?: number;
  visitedById?: number;
  person!: Person;
  type!: VisitType;
  visitedBy!: Person;
}

